import * as React from "react";
import styled from "@emotion/styled";
import { css } from '@emotion/core';
import Hero from "./components/Hero";
// import PassportBlock from "./components/PassportBlock";
import InnerPage from "../Core/components/InnerPage";
import { PrimaryLink } from "../Core/components/Buttons";
import { asset } from './components/helpers';
import mq from "../Styles/breakpoints";
import fontSize from "../Styles/text";
import StreamingOptions from "./components/StreamingOptions";
import padding from "../Styles/padding";
import { App as Swimlane } from "../VideoRows/App";
import SubscriptionForm from "./components/SubscriptionForm";

let SectionHeading = styled.h2`
  margin: ${padding.xxlarge} ${padding.standard};
  margin-top: calc(32px + (64 - 32) * ((100vw - 320px) / (1920 - 320)));
  text-align: center;

  // https://css-tricks.com/snippets/css/fluid-typography/
  // font-size: calc([minimum size] + ([maximum size] - [minimum size]) * ((100vw - [minimum viewport width]) / ([maximum viewport width] - [minimum viewport width])));
  font-size: calc(28px + (48 - 28) * ((100vw - 320px) / (1920 - 320)));
`;

let SubHeading = styled.p`
  font-size: calc(20px + (32 - 20) * ((100vw - 320px) / (1920 - 320)));
`;

let AppsHeading = styled(SectionHeading)`
  margin-top: calc(32px + (96 - 32) * ((100vw - 320px) / (1920 - 320)));
`;

let AppLogos = styled.div`
  max-width: 800px;
  margin: 0 auto;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-wrap: wrap;

  img {
    padding: ${padding.large};
  }
`;

let PBSLogo = styled(AppLogos)`
  margin: 32px auto;
`;

let ShowRow = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
`;

let FormHeading = styled(SectionHeading)`
  margin: calc(12px + (48 - 12) * ((100vw - 320px) / (1920 - 320))) 0;
`;

let KidsRow = styled.div`
  position: relative;
  height: calc(180px + (350 - 180) * ((100vw - 320px) / (1920 - 320)));
  margin: calc(32px + (80 - 32) * ((100vw - 320px) / (1920 - 320))) 0;
  overflow: hidden;
`;

let Background = styled.img`
  position: absolute;
  top: 50%;
  width: 100%;
  display: block;
  transform: translateY(-50%);

  @media(min-width: 640px) {
    top: 60%;
  }
`;

let KidsRowInner = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  & > ${SectionHeading} {
    margin-top: 0;
    color: #fff;
    font-weight: 700;
    font-size: calc(28px + (64 - 28) * ((100vw - 320px) / (1920 - 320)));
  }

  a {
    font-size: calc(18px + (24 - 18) * ((100vw - 320px) / (1920 - 320)));
  }
`;

let PromoImages = styled.div`
  max-width: 1024px;
  margin: 64px auto 0;
  padding: 0 48px;
  display: grid;

  @media(min-width: 769px) {
    grid-template-columns: 1fr 1fr;
    grid-gap: 48px;
  }
`;

let passportrows = [['', 'show/streaming/', { view: 'show' }]];

export default function App({ isMobile }) {
  return (
    <React.Fragment>
      <Hero />

      <InnerPage>
        <SectionHeading>
          Constantly adding shows you love
        </SectionHeading>
      </InnerPage>

      <StreamingOptions />

      <InnerPage>
        <SectionHeading>
          Do all 3 with the PBS App
        </SectionHeading>
      </InnerPage>

      <AppLogos>
        <a href="https://apps.apple.com/us/app/pbs-video/id398349296?ct=&amp;pt=294784" rel="noopener noreferrer" target="_blank"><img src={asset('streaming/apps/ios.png')} alt="Get the PBS APP on iOS" /></a>
        <a href="https://apps.apple.com/us/app/pbs-video/id398349296?ct=&amp;pt=294784" rel="noopener noreferrer" target="_blank"><img src={asset('streaming/apps/apple-tv.png')} alt="Get the PBS APP on Apple TV" /></a>
        <a href="https://channelstore.roku.com/details/2926d0a0c976db9bfcc86d2364ff9dbc/pbs" rel="noopener noreferrer" target="_blank"><img src={asset('streaming/apps/roku.png')} alt="Get the PBS APP on Roku" /></a>
        <a href="https://play.google.com/store/apps/details?id=com.pbs.video&amp;hl=en_US&amp;showAllReviews=true" rel="noopener noreferrer" target="_blank"><img src={asset('streaming/apps/android.png')} alt="Get the PBS APP on Android" /></a>
        <a href="https://www.amazon.com/Public-Broadcasting-Service-PBS-Video/dp/B008Z2NVGK" rel="noopener noreferrer" target="_blank"><img src={asset('streaming/apps/fire-tv.png')} alt="Get the PBS APP on Fire TV" /></a>
        <a href="https://help.pbs.org/support/search?term=chromecast" rel="noopener noreferrer" target="_blank"><img src={asset('streaming/apps/chromecast.png')} alt="Get the PBS APP on Chromecast" /></a>
        <a href="https://play.google.com/store/apps/details?id=com.pbs.video&amp;hl=en_US&amp;showAllReviews=true" rel="noopener noreferrer" target="_blank"><img src={asset('streaming/apps/android-tv.png')} alt="Get the PBS APP on Android TV" /></a>
        <a href="https://www.samsung.com/us/appstore/app.do?appId=G19045012525" rel="noopener noreferrer" target="_blank"><img src={asset('streaming/apps/samsung.png')} alt="Get the PBS APP on Samsung TV" /></a>
        <a href="https://www.vizio.com/en/smart-tv-apps?appName=pbs&amp;appId=vizio.pbs" rel="noopener noreferrer" target="_blank"><img src={asset('streaming/apps/vizio.png')} alt="Get the PBS APP on Vizio TV" /></a>
      </AppLogos>

      <PBSLogo>
        <img src={asset('streaming/apps/pbs-video-app.png')} alt="" aria-hidden="true" />
      </PBSLogo>

      <InnerPage>
        <SectionHeading style={{ marginBottom: 0 }}>
          Explore On-Demand Shows
        </SectionHeading>
      </InnerPage>

      <Swimlane mobileView={isMobile} rows={passportrows} breakpoints={[[1400, 7], [1200, 5], [900, 4], [600, 3], [0, 2]]} />


      <KidsRow>
        <Background
          src={asset('streaming/kids-banner.jpg')}
          srcSet={`${asset('streaming/kids-banner.jpg')} 1920w, ${asset('streaming/kids-banner.1440.jpg')} 1440w, ${asset('streaming/kids-banner.1366.jpg')} 1366w, ${asset('streaming/kids-banner.768.jpg')} 768w, ${asset('streaming/kids-banner.480.jpg')} 480w, ${asset('streaming/kids-banner.320.jpg')} 320w`}
          sizes={"(max-width: 320px) 320px, (max-width: 480px) 480px, (max-width: 768px) 768px, (max-width: 1366px) 1366px, (max-width: 1400px) 1400px, 1920px"}
          alt=""
        />
        <KidsRowInner>
          <SectionHeading>Looking for TPT Kids?</SectionHeading>
          <a href="https://www.tpt.org/kids/" className="outline-btn">Find it here</a>
        </KidsRowInner>
      </KidsRow>

      <PromoImages>
        <img src={asset('streaming/tv-screen.png')} alt="" />
        <img src={asset('streaming/app-screen.png')} alt="" />
      </PromoImages>

      <InnerPage>
        <SectionHeading>
          Any Questions?
        </SectionHeading>
        <p style={{ marginBottom: '72px', textAlign: 'center', fontSize: '24px' }}>Visit the <a href="https://help.pbs.org/support/solutions/12000002757" target="_blank" rel="noopener noreferrer">Streaming FAQ</a> page.</p>
      </InnerPage>
    </React.Fragment>
  );
}
